module.exports = __webpack_public_path__ + "img/videodraft.cad8db50.jpg";